import React from "react";
import LoadingWidget from "./LoadingWidget";

function Widget() {

    return (
      <div className="absolute top-3 right-12">
        <LoadingWidget />
        <div className="absolute bottom-1 right-2">
          <div className="elfsight-app-b8a56f1e-13f0-420d-a542-091d4e218b2d"></div>
        </div>

      </div>
    );

}

export default Widget;
